module.exports = __webpack_public_path__ + "static/img/not-found.40385d64.svg";